import React from "react"
import "../../SignIn/SignIn.scss"
import LoginSignUp from "../../../hoc/LoginSignUp/LoginSignUp"
import { FieldGroup, FieldControl } from "react-reactive-form"
import { FormGroups } from "../../../components/ReusableComponents/FormGroups/FormGroups"
import { CheckValid } from "../../../services/CommonFunction"
import { TextInput } from "../../../components/UI/FormInput/FormInput"
import SocialLogin from "../../../components/SocialLogin/SocialLogin"

const SignUp = ({ SignupForm, handleSubmit, navigate }) => {
  return (
    <div className="formDetailContainer">
      <FieldGroup
        control={SignupForm}
        render={({ get, invalid }) => (
          <form onSubmit={handleSubmit}>
            <FormGroups>
              <FieldControl
                name="email"
                render={TextInput}
                meta={{
                  label: "Email address",
                  showLabel: false,
                  type: "email",
                  placeholder: "Email address",
                  placeHolderIcon: "emailInput",
                  valid: true,
                  showError: true,
                }}
              />
            </FormGroups>
            <FormGroups>
              <FieldControl
                name="password"
                render={TextInput}
                meta={{
                  label: "Password",
                  showLabel: false,
                  type: "password",
                  placeholder: "Password",
                  placeHolderIcon: "passwordInput",
                  minLength: "10",
                  maxLength: "50",
                  valid: true,
                  showError: true,
                }}
              />
            </FormGroups>
            <div className="textDiv">
              <div className="validation_group">
                <p style={{ color: "#979797" }}>Your password must:</p>
                <CheckValid get={get} />
              </div>
            </div>
            <div className="submitDiv">
              <button
                className={`${invalid ? "disabled" : "enabled"}`}
                type="submit"
              >
                <p>Sign Up</p>
              </button>
              <div className="signUpDiv">
                <p className="brightText">Already have an account?</p>
                <p className="brightText">
                  <span onClick={() => navigate("SignIn")}>Login</span> instead
                </p>
              </div>
            </div>
            <hr />
          </form>
        )}
      />
      <SocialLogin />
    </div>
  )
}

const headerDetail = {
  heading: "Welcome ,",
  subHeading1: "Join the best digital fitness",
  subHeading2: "experience now!",
  subHeading3: null,
  isLogoRequired: true,
  status: "signup",
}

const SignUpComponent = LoginSignUp(SignUp, headerDetail)
export default SignUpComponent
